<button class="c-button c-button--tp u-no-p" type="button" id="openPopUpInfoButton-{{vm.itemId}}" (click)="vm.handleRefButtonClick()" (mouseenter)="vm.handleRefButtonMouseEnter()" data-ref>
	<i class="o-icon o-icon--info" aria-hidden="true" [ngStyle]="vm.color && {'color':vm.color}"></i>
</button>
<div class="c-popover" *ngIf="vm.isOpen">
	<div class="c-popover__container">
		<button style="padding:5px;" type="button" class="c-popover__close" id="closePopUpInfoButton-{{vm.itemId}}" (click)="vm.handleCloseButtonClick()">
			<i class="o-icon o-icon--x" aria-hidden="true"></i>
			<span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
		</button>
		<p style="padding:10px;" id="infoTextContainer" class="c-text" [innerHtml]="vm.text"></p>
	</div>
</div>
